import { OperationalRole, OwnershipNature } from 'src/types/governance.types';

export enum HouseholdCostBearerMode {
  REPRESENTATIVE = 'REPRESENTATIVE',
  OWNERS_SPLIT = 'OWNERS_SPLIT',
}

export interface HouseholdMemberDto {
  id: string;
  userId?: string;
  isPlaceholder: boolean;
  placeholderMemberId?: string;
  firstName?: string;
  lastName?: string;
  operationalRole?: OperationalRole;
  isAssetOwner: boolean;
  householdId?: string;
  householdName?: string;
  shares?: number;
  sharesPct: number;
  ownershipNature?: OwnershipNature;
}

export interface OwnershipSummaryDto {
  fullOwnershipPct: number;
  bareOwnershipPct: number;
  usufructPct: number;
  capitalSharePct: number;
  capitalShareTantiemes?: number;
}

export interface HouseholdDto {
  id: string;
  name: string;
  color: string;
  costBearerMode: HouseholdCostBearerMode;
  head?: HouseholdMemberDto;
  members: HouseholdMemberDto[];
  ownershipSummary: OwnershipSummaryDto;
  createdAt: string;
  updatedAt: string;
}

export interface CreateHouseholdDto {
  name: string;
  color: string;
  costBearerMode?: HouseholdCostBearerMode;
  headMemberId?: string;
  memberIds?: string[];
}

export type UpdateHouseholdDto = Partial<CreateHouseholdDto>;

export interface HouseholdBalanceDto {
  householdId: string;
  name: string;
  color: string;
  netBalance: number;
}
